<mat-sidenav-container
  class="mainWrapper"
  autosize
  autoFocus
  [ngClass]="{
  'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top' &&  !resView && !cabinShell && !attentionShell,
  'sidebarNav-horizontal': options.horizontal,
  cardBorder: options.cardBorder,
  'cabin-shell': cabinShell,
  'attention-shell': attentionShell,
}"
  [dir]="options.dir!"
>
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->
  @if (!options.horizontal && !cabinShell) {
  <mat-sidenav
    #leftsidenav
    [mode]="isOver ? 'over' : 'side'"
    [opened]="
      options.navPos === 'side' && options.sidenavOpened && !isOver && !resView
    "
    (openedChange)="onSidenavOpenedChange($event)"
    (closedStart)="onSidenavClosedStart()"
    class="sidebarNav"
    [class.attention-sidenav]="attentionShell"
  >
    @if (attentionShell) {
    <div class="flex-layout attention-sidenav-inner">
      <ng-scrollbar class="position-relative flex-1" style="height: 100%">
        <app-attention-sidebar (itemNavigate)="sidenav.toggle()" />
      </ng-scrollbar>
      <div class="p-24 m-t-auto profile-bar d-flex justify-content-center">
        <button
          mat-mini-fab
          class="logout-btn"
          type="button"
          (click)="onLogout()"
          matTooltip="Cerrar sesión"
          aria-label="Cerrar sesión"
        >
          <i-tabler name="power" class="icon-18"></i-tabler>
        </button>
      </div>
    </div>
    } @else {
    <div class="flex-layout">      <app-sidebar
        (toggleMobileNav)="toggleSidenav()"
        [showToggle]="isOver"
      ></app-sidebar>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for(item of navItems; track item) {
          <app-nav-item [item]="item" (notify)="sidenav.toggle()">
          </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
      <div class="p-24 m-t-auto profile-bar d-flex justify-content-center">
        <button
          mat-mini-fab
          class="logout-btn"
          type="button"
          (click)="onLogout()"
          matTooltip="Cerrar sesión"
          aria-label="Cerrar sesión"
        >
          <i-tabler name="power" class="icon-18"></i-tabler>
        </button>
      </div>
    </div>
    }
  </mat-sidenav>
  }
  <!-- ============================================================== -->
  <!-- horizontal Sidebar (only shown in responsive view) -->
  <!-- ============================================================== -->  @if (resView && !options.sidenavOpened && !cabinShell) {
  <mat-sidenav
    #mobilesidenav
    [mode]="'over'"
    [opened]="options.sidenavOpened && !isTablet"
    (openedChange)="onSidenavOpenedChange($event)"
    (closedStart)="onSidenavClosedStart()"
    class="sidebarNav"
  >    @if (attentionShell) {
    <ng-scrollbar class="position-relative" style="height: 100%">
      <app-attention-sidebar (itemNavigate)="mobileSidenav.toggle()" />
    </ng-scrollbar>
    } @else {
    <app-sidebar (toggleMobileNav)="mobileSidenav.toggle()" [showToggle]="isOver">
    </app-sidebar>
    <ng-scrollbar class="position-relative" style="height: 100%">
      <mat-nav-list class="sidebar-list">        @for(item of navItems; track item) {
        <app-nav-item [item]="item" (notify)="mobileSidenav.toggle()"> </app-nav-item>
        }
      </mat-nav-list>
    </ng-scrollbar>
    }
    <div class="p-24 m-t-auto profile-bar d-flex justify-content-center">
      <button
        mat-mini-fab
        class="logout-btn"
        type="button"
        (click)="onLogout()"
        matTooltip="Cerrar sesión"
        aria-label="Cerrar sesión"
      >
        <i-tabler name="power" class="icon-18"></i-tabler>
      </button>
    </div>
  </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content
    class="contentWrapper"
    [ngClass]="{ 'p-l-24 p-r-24': !options.horizontal }"
    #content
  >
    <!-- horizontal header -->    @if(options.horizontal) {
    <app-horizontal-header
      (toggleMobileNav)="toggleSideNav()"
      (toggleMobileFilterNav)="filterNavRight.toggle()"
      (optionsChange)="receiveOptions($event)"
    ></app-horizontal-header>
    } @if(options.horizontal) {
    <ng-container>
      <app-horizontal-sidebar></app-horizontal-sidebar>
    </ng-container>
    }

    <main
      class="pageWrapper"
      [ngClass]="{
        maxWidth: options.boxed
      }"
    >
      @if(!options.horizontal) {
      <ng-container>        <app-header
          [showToggle]="!cabinShell && !attentionShell && !isOver"
          [showGlobalSearch]="attentionShell"
          (toggleCollapsed)="toggleCollapsed()"
          (toggleMobileNav)="toggleSideNav()"
          (toggleMobileFilterNav)="filterNavRight.toggle()"
          (optionsChange)="receiveOptions($event)"
        ></app-header>
      </ng-container>
      }
      @if (cabinShell) {
        <app-cabin-tab-bar></app-cabin-tab-bar>
      }
      <div class="m-t-30" [ngClass]="{ 'p-l-24 p-r-24': options.horizontal, 'm-t-8': cabinShell }">
        @if (!cabinShell) {
        <app-breadcrumb></app-breadcrumb>
        }
        <!-- ============================================================== -->
        <!-- Outlet (spinner de ruta: lazy load dashboards antes de montar D1–D4) -->
        <!-- ============================================================== -->
        <div class="vp-dashboard-route-host">
          <router-outlet></router-outlet>
          @if (dashboardRouteLoading) {
            <div class="vp-dashboard-route-boot" aria-live="polite" aria-busy="true">
              <mat-spinner diameter="48"></mat-spinner>
              <p class="f-s-14 text-muted m-0">Cargando panel…</p>
            </div>
          }
        </div>
      </div>
      @if (!cabinShell && !attentionShell) {
      <div class="customizerBtn">
        <button
          mat-fab
          class="bg-primary text-white"
          (click)="customizerRight.toggle()"
        >
          <mat-icon>settings</mat-icon>
        </button>
      </div>
      }
    </main>
  </mat-sidenav-content>

  <mat-sidenav
    #customizerRight
    mode="over"
    position="end"
    class="customizerNav"
  >
    <div
      class="p-x-16 p-y-20 d-flex align-items-center justify-content-between"
    >
      <h3 class="f-s-21 f-w-600">Configuración</h3>

      <button class="d-lg-none" mat-button (click)="customizerRight.toggle()">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
      </button>
    </div>

    <app-customizer (optionsChange)="receiveOptions($event)"></app-customizer>
  </mat-sidenav>
</mat-sidenav-container>

<!-- ------------------------------------------------------------------
  Mobile Apps Sidebar
  ------------------------------------------------------------------ -->
<mat-drawer #filterNavRight mode="over" position="end" class="filter-sidebar">
  <div class="p-24 d-flex justify-content-center">
    <button
      mat-mini-fab
      class="logout-btn"
      type="button"
      (click)="onLogout()"
      matTooltip="Cerrar sesión"
      aria-label="Cerrar sesión"
    >
      <i-tabler name="power" class="icon-18"></i-tabler>
    </button>
  </div>
</mat-drawer>
